import { Chip } from "@mui/material";
import AndroidIcon from "@mui/icons-material/Android";

import { ReactElement } from "react";
import { FieldProps, useRecordContext } from "react-admin";

const knownIds: Record<string, string> = {
    "gclid": "google",
    "fbclid": "facebook",
    "ysclid": "yandex"
}
const iconsRoot = "../../../assets/social/"
const Icons: Record<string, (props: any) => ReactElement> = import.meta.glob("../../../assets/social/*.svg", {
    import: 'default',
    query: '?react',
    eager: true
})


const Icon = ({ id, ...props }: any) => Icons[`${iconsRoot}${id}.svg`]({ ...props });

export const MetadataField = (props: Omit<FieldProps, "source">) => {
    const record = useRecordContext(props);
    if (record?.metadata) {
        const clids = Object.keys(record.metadata).filter(key => key.endsWith("clid"));
        console.log(clids)
        // install_time / click_time are set by the Google Play Install Referrer API,
        // which means the user installed/opened the app via the TWA on Google Play.
        const isGooglePlay = !!(record.metadata.install_time || record.metadata.click_time);
        return (
            <>
                {clids.map(clid =>
                    <Chip key={clid} label={clid}
                        icon={knownIds[clid] ? <Icon id={knownIds[clid]} viewBox="0 0 512 512" width={24} height={24} /> : undefined} />)
                }
                {isGooglePlay && (
                    <Chip label="TWA" icon={<AndroidIcon />} />
                )}
            </>
        )

    } else
        return null

}